import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';

import { FormService } from '../form.service';

import get from 'lodash-es/get';
import set from 'lodash-es/set';

@Component({
  selector: 'app-form-template-card-panel',
  templateUrl: './form-template-card-panel.component.html',
  styleUrls: ['./form-template-card-panel.component.scss'],
})
export class FormTemplateCardPanelComponent implements OnInit {
  @Input() actions?: any[];
  @Input() description?: string;
  @Input() disableActionBar: boolean;
  @Input() disableForms?: boolean;
  @Input() disableFormsText?: string;
  @Input() forms: any[];
  @Input() headerAction?: any;
  @Input() title: any;
  @Input() validators: any[];
  @Output() formChanged: EventEmitter<any> = new EventEmitter();
  formGroup: UntypedFormGroup;

  constructor(private formService: FormService) {}

  ngOnInit(): void {
    this.formGroup = this.formService.generateFormGroup(
      this.forms,
      this.validators,
    );
  }

  formChange({ update, formGroup }: any): void {
    if (formGroup) {
      this._disableActions(get(this, 'actions', []), formGroup.invalid);
    }
    this.formChanged.emit(update);
  }

  _disableActions(actions: any[], disableAction: boolean): any[] {
    return actions.map((action: any) => set(action, 'disable', disableAction));
  }

  actionClick(action: any, formGroup: any) {
    action.callback(formGroup.value);
  }
}
